<ng-container *ngIf="isAnyRecordAvailable">
  <mat-card class="filter">
    <div class="orgcount">
      <div class="all">
        <button mat-button [matMenuTriggerFor]="menu"><mat-icon>list</mat-icon>
          List<mat-icon>keyboard_arrow_down</mat-icon></button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="CCCListing()"><mat-icon>list</mat-icon> List View</button>
          <button mat-menu-item (click)="CCCKanban()"><mat-icon>view_kanban</mat-icon> Kanban View</button>
          <button mat-menu-item (click)="CCCGridView()"><mat-icon>group_work</mat-icon> Grouping view</button>

        </mat-menu>

        <button mat-flat-button [matMenuTriggerFor]="notification" class="user-button">
          {{ Filtername}} ({{allrecordcount}}) <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu class="customPanel" #notification="matMenu">
          <mat-card class="filterOption">
            <div class="fillist">
              <label>Saved Filter</label>
              <div class="filterlist">
                <ng-container *ngFor="let filter of FilterNameList">
                  <div class="lList">
                    <span class="name" (click)="OnFilterNameClick(filter)">{{filter.filterName}}</span>
                    <ng-container *ngIf="getIsFavoriteForFilter(filter) == true; else showFavorite">
                      <button *ngIf="filter.filterName!='Review'" mat-icon-button
                        (click)="DeleteFavoriteForFilter(filter)">
                        <mat-icon class="fav star">bookmark</mat-icon>
                      </button>
                    </ng-container>

                    <ng-template #showFavorite>

                      <button mat-icon-button (click)="AddFavoriteForFilter(filter)" *ngIf="filter.filterName!='Recent' &&
                    filter.filterName!='Review'">
                        <mat-icon class="star">bookmark</mat-icon>
                      </button>

                    </ng-template>
                    <!-- <button mat-icon-button class="remove" 
                   *ngIf="filter.filterName!='Recent' && filter.filterName!='Starred'
                          && filter.filterName!='All Company' && filter.filterName!='All Core'
                          && filter.filterName!='All Contact'
                          && filter.filterName!='Review'" (click)="RemoveFilter(filter)">
                    <mat-icon class="">highlight_off</mat-icon> 
                  </button> -->
                    <button mat-icon-button class="remove" *ngIf="filter.filterID!=0
                          && filter.filterID!=-1
                          && filter.filterID!=-2 
                          && filter.filterID!=-3" (click)="RemoveFilter(filter)">
                      <mat-icon class="">highlight_off</mat-icon>
                    </button>
                  </div>

                </ng-container>

              </div>

            </div>
            <button class="crtfil" mat-menu-item (click)="ArchivedFilter()">Archived</button>

            <button class="crtfil" mat-menu-item (click)="applyFilter()">Create a Custom Filter</button>
          </mat-card>
        </mat-menu>
      </div>

      <ng-container *ngIf="SelectedRecordForDeleFav && Filtername!='Archived'">
        <div class="slAct">
          {{selectedRecordDeleteArray.length}}
          <button mat-icon-button matTooltip="Add Favorite"><mat-icon
              (click)="AddFavorite()">star_outline</mat-icon></button>
          <button mat-icon-button matTooltip="Archive Record"><mat-icon
              (click)="ArchiveRecord()">restore_from_trash</mat-icon></button>
          <button mat-icon-button matTooltip="Delete Record"><mat-icon
              (click)="DeleteRecord()">delete_outline</mat-icon></button>
          <button mat-icon-button *ngIf="BroadCastHide" matTooltip="Add BroadCast"><mat-icon
              (click)="broadcastMessage(broadCast)">podcasts</mat-icon></button>

          <button *ngIf="ShowPaycheck==true" [disabled]="!showPaycheck" mat-icon-button matTooltip="Send to Paychex">
            <mat-icon (click)="SendtoPaychex()">local_parking</mat-icon>
          </button>

          <button *ngIf="ShowPointClickCare==true"  [disabled]="!showPCC"  mat-icon-button matTooltip="Send to PointClickCare">
            <img (click)="SendtoPendingPatientPCC()" style="height: 22px;margin-top: -10px;"
            class="payCheckIcon" src="../../../../assets/icons/pccfavicon-32x32.png"/>
           </button>

           <button mat-icon-button matTooltip="Attach Tasks">
             <mat-icon (click)="AttachToTaskList()">task_alt</mat-icon>
           </button>

           <button mat-icon-button matTooltip="Send Form">
            <mat-icon (click)="ImportForm3CTaskList()">send</mat-icon>
          </button>

          <button *ngIf="showAction==true" mat-icon-button matTooltip="Move To">
            <mat-icon (click)="MoveToOtherOffice()">low_priority</mat-icon>
          </button>

        </div>
      </ng-container>

      <button mat-icon-button matTooltip="Download Documents">
        <mat-icon (click)="openDownloadPanel(downloadDoc)">cloud_download</mat-icon>
      </button>

      <ng-container *ngIf="Filtername=='Archived'">
        <div class="slAct" *ngIf="SelectedRecordForDeleFav">
          {{selectedRecordDeleteArray.length}}
          <button mat-icon-button matTooltip="Delete Record"><mat-icon
              (click)="DeleteRecord()">delete_outline</mat-icon>
           </button>
          <button mat-icon-button matTooltip="Activate Record"><mat-icon
              (click)="ActivateRecord()">auto_fix_high</mat-icon>
          </button>
        </div>
      </ng-container>

    </div>


    <div class="search">
      <mat-form-field appearance="">
        <mat-label>Search items in {{modulename}} </mat-label>
        <input matInput type="text" [(ngModel)]="value"
          (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)">
        <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
        <button color="basic" *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <!-- <button (click)="downloadFile()">Download All files</button> -->
    
    <button class="viewBtn" mat-icon-button (click)="customizeColumn(customize)" matTooltipClass="tooltip"
      matTooltip="Customize Column">
      <mat-icon>view_column</mat-icon>
    </button>

    <button class="filterList" mat-icon-button [ngClass]="{'active':filterApplied}" (click)="applyFilter()"
      matTooltipClass="tooltip" matTooltip="Filters">
      <mat-icon>filter_list</mat-icon>
    </button>

    <button matTooltipClass="tooltip" matTooltip="Export" mat-icon-button
      *ngIf="isAnyRecordAvailable && paginatorTotalLength!=0">
      <mat-icon (click)="ExportData(export)">ios_share</mat-icon>
    </button>

    <button matTooltipClass="tooltip" matTooltip="Add Record" mat-flat-button color="primary" (click)="addNew()"
      class="addnew">
      Add New
    </button>

  </mat-card>

  <div class="zui-wrapper">
    <div class="zui-scroller">

      <mat-table [style.width]="colCount*200+'px'" class="zui-table" cdkDropList cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="dropListDroppedEvent($event)" [dataSource]="dataSource" matSort matSortDisableClear
        matSortDirection="asc" (matSortChange)="announceSortChange($event)">

        <ng-container *ngFor="let column of filteredList; let i = index" [matColumnDef]="column.fieldName">

          <mat-header-cell mat-sort-header *matHeaderCellDef cdkDrag cdkDragLockAxis="x">
            <ng-container *ngIf="i == 0">
              <div class="checkOrgname">

                <mat-checkbox color="primary" [checked]="checkedAll" (change)="getCheckboxAll($event)"
                (click)="$event.stopPropagation()"></mat-checkbox>
               
                <div class="name">
                  <span>{{column.fieldName}}</span>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="i != 0">
              <span>{{column.fieldName}} <mat-icon>sort</mat-icon> </span>
            </ng-container>

          </mat-header-cell>


          <mat-cell *matCellDef="let element" (click)="showListingDetail(element,column.fieldName)">

            <ng-container *ngIf="i == 0">
              <div class="checkOrgname">

                <mat-checkbox color="primary" [checked]="element.IsChecked"
                  (change)="getCheckboxParticular($event,element)"></mat-checkbox>

                <ng-container *ngIf="getIsFavorite(element) == true; else showFavorite">
                  <mat-icon class="fav star" (click)="DeleteFavorite(element)">grade</mat-icon>
                </ng-container>

                <ng-template #showFavorite>
                  <mat-icon class="star" (click)="AddRowFavorite(element)">grade</mat-icon>
                </ng-template>


                <ng-template #showpaychexID>
                  <!-- <mat-icon class="star" (click)="AddRowFavorite(element)">grade</mat-icon> -->
                </ng-template>


                <div class="name" (click)="ViewProfile(element)">
                  <div class="userpicinfo ">
                    <ng-container *ngIf="getImageUrlPath(element).substring(0,4) == 'http'; else showName">
                      <div class="userImage">
                        <img src="{{getImageUrlPath(element)}}">
                      </div>
                    </ng-container>
                    <ng-template #showName>
                      <span class="shortName">{{getShortName(element)}}</span>
                    </ng-template>
                  </div>
                  <div class="orgname text-truncate">
                    {{getFullName(element,column)}}
                  </div>
                </div>

                <ng-container *ngIf="getpaychexID(element) != null; else showpaychexID">
                  <mat-icon class="payCheckIcon" color="primary">local_parking</mat-icon>
                </ng-container>

                <ng-container *ngIf="getPendingPatientID(element) != null; else showpaychexID">                
                  
                    <img style="height: 22px;" class="payCheckIcon"
                      src="../../../../assets/icons/pccfavicon-32x32.png"/>
                </ng-container>

                <ng-container>
                  <button mat-icon-button color="primary" class="openNew"  matTooltip="Open in new window" (click)="OpenProfile(element)">
                    <mat-icon>open_in_new</mat-icon> </button>
                </ng-container>

              </div>
            </ng-container>



             <!-- Phone & Email case -->
            <ng-container *ngIf="i != 0 && column.fieldTypeID!=9 && column.fieldName != 'Address'">
              
              <ng-container *ngIf="isPhone(element, column.fieldName)">
                <app-email-phone [onlyPhone]="element[column.fieldName]" [location]="'listing'" ></app-email-phone> 
              </ng-container>

              <ng-container *ngIf="isEmail(element, column.fieldName)">
                <app-email-phone [onlyEmail]="element[column.fieldName]"  [location]="'listing'"></app-email-phone> 
              </ng-container>

              <ng-container *ngIf="!isPhone(element, column.fieldName) && !isEmail(element, column.fieldName) && column.fieldName != 'Status' ">
                {{element[column.fieldName]}}
              </ng-container>

            </ng-container>

            <!-- email case -->
            <ng-container *ngIf="i != 0 && column.fieldTypeID==9 && column.fieldName != 'Address'" >
              <ng-container *ngIf="element[column.fieldName] != '—'">
                <a (click)="goToLink(element[column.fieldName])" target="_blank"><u> 
                  {{ element[column.fieldName]}}</u></a>
              </ng-container>
              <ng-container *ngIf="element[column.fieldName] == '—'">
                {{ element[column.fieldName]}}
              </ng-container>
            </ng-container>

            <ng-container *ngIf="i != 0 && column.fieldName == 'Status' && element[column.fieldName] != '—' && column.fieldTypeID!=9 ">
              <div class="statusColor" [ngStyle]="{ background: getStatusColor(element[column.fieldName]) }" >   {{element[column.fieldName]}} </div>
            </ng-container>
			
           <ng-container *ngIf="i != 0 && column.fieldName == 'Address' && element[column.fieldName] != '—' && column.fieldTypeID!=9 ">
            <span class="addressCol" >{{element[column.fieldName]}}</span>
            </ng-container>

            <ng-container *ngIf="i != 0 && column.fieldName == 'Address' && element[column.fieldName] == '—' && column.fieldTypeID!=9 ">
            <span class="addressCol" >{{element[column.fieldName]}}</span>
            </ng-container>

          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns;  sticky: true" class="tableHeaderRow"
          #tableHeaderRow></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

      </mat-table>

      <div *ngIf="paginatorTotalLength==0">
        <p>No Record Found</p>
      </div>
    </div>
  </div>

  <span>
    <mat-paginator #paginator [length]="paginatorTotalLength" [pageIndex]="pageIndex" [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions" itemsPerPageLabel="Records Per Page" showFirstLastButtons="true"
      (page)="pageEventPropogate($event)">
    </mat-paginator>
  </span>
</ng-container>


<mat-card *ngIf="!isAnyRecordAvailable && paginatorTotalLength==0" class="noRecord">
  <div class="noData">
    <mat-icon>post_add </mat-icon>
    <p *ngIf="Filtername!=='Archived'">Looks like you don't have any records. That's why this part it's empty!</p>
    <button *ngIf="Filtername!=='Archived'" mat-flat-button color="primary" (click)="addNew()"> Add New</button>
    <p *ngIf="Filtername=='Archived'">Looks like you don't have any archived records. That's why this part it's empty!
    </p>
    <button *ngIf="Filtername=='Archived'" mat-flat-button color="primary" (click)="showAllRecords()"> Go Back to Active
      Record</button>
  </div>
</mat-card>


<ng-template #customize>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Select the columns you want to display in this list
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="fixrow sep">
        <span>Column Headers</span>
        <span> Active Columns</span>
      </div>

      <ng-container *ngFor="let item of FieldColumnToogle;let i = index">
        <div class="sep" *ngIf="i==0">
          <span>{{item.fieldName}}</span>
          <span>
            <mat-slide-toggle checked disabled color="primary"></mat-slide-toggle>
          </span>
        </div>
        
        <div class="sep" *ngIf="i!=0">
          <span>{{item.fieldName}}</span>
          <span>
            <mat-slide-toggle *ngIf="item.fieldName!='Status'" [checked]="item.isDisplay" color="primary" (change)="changedToggle(item,$event)">
            </mat-slide-toggle>

            <mat-slide-toggle *ngIf="item.fieldName=='Status'" checked disabled color="primary"></mat-slide-toggle>

          </span>
        </div>
      </ng-container>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!SubmitColumnsButton" (click)="onSubmitColumns()">Save</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #broadCast>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>podcasts</mat-icon>
    </span>
    Broadcast Message
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="">

      <div class="broadSection">
        <p>Note: Broadcast Your Message Through

          <span *ngIf="!isChecked">Text Message</span>
          <span *ngIf="isChecked">Email</span>

        </p> <mat-slide-toggle [(ngModel)]="isChecked" color="primary"></mat-slide-toggle>
      </div>

      <mat-form-field appearance="" class="mt-10" appearance="fill">
        <mat-label>Select Relation</mat-label>
        <mat-select multiple>
          <mat-option value="one">Father</mat-option>
          <mat-option value="two">Brother</mat-option>
          <mat-option value="one">Buyer</mat-option>
          <mat-option value="two">Seller</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <mat-label>Add Subject</mat-label>
        <input matInput placeholder="Write Subject" value="">
      </mat-form-field>

      <mat-form-field appearance="">
        <mat-label>Message</mat-label>
        <textarea matInput placeholder="Write your broadcast message here..." style="min-height: 120px;"></textarea>
      </mat-form-field>

    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Send</button>
  </mat-dialog-actions>
</ng-template>

<!-- Export -->
<ng-template #export>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Select the columns you want to export in this list
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <span class="" *ngIf="Feildproperty.length==0">Loading data please wait..</span>

  <mat-dialog-content class="mat-typography" *ngIf="Feildproperty.length>0">
    <div class="">
      <div class="broadSection">
        <div class="broadSelected">
          <span *ngIf="SelectedRecords">Selected Records</span>
          <span *ngIf="AllRecords">All Records</span>
          <mat-slide-toggle color="primary" (change)="selectOptionForExport($event)"
            [disabled]="allRecord"></mat-slide-toggle>
        </div>
      </div>

      <!-- <mat-form-field appearance="fill">
      <mat-label>Choose an option</mat-label>
      <mat-select [(value)]="Records" (selectionChange)="selectOptionForExport($event)">
        <mat-option value="SelectedRecords" [disabled]="allRecord">Selected Records</mat-option>
        <mat-option value="AllRecords">All Records</mat-option>      
      </mat-select>
    </mat-form-field> -->

      <div class="allheaders">
        <div class="align-toright">
          <mat-slide-toggle color="primary" [checked]="toggleAll" (change)="getToggleAll($event)"></mat-slide-toggle>
        </div>
        <div class="fixrow sep">
          <span>Column Headers</span>
          <span>Export Columns</span>
        </div>

        <ng-container *ngFor="let item of Feildproperty;let i = index">
          <div class="sep" *ngIf="i==0">
            <span>{{item.fieldName}}</span>
            <span>
              <mat-slide-toggle color="primary" [checked]="item.IsExport" [disabled]=true></mat-slide-toggle>
              <!-- <mat-checkbox color="primary" [checked]="item.IsExport" [disabled]=true></mat-checkbox>-->
            </span>
          </div>
          <div class="sep" *ngIf="i!=0">
            <span>{{item.fieldName}}</span>
            <span>
              <mat-slide-toggle color="primary" [checked]="item.IsExport" (change)="getToggleParticular($event,item)">
              </mat-slide-toggle>
              <!-- <mat-checkbox color="primary" [checked]="item.IsExport" (change)="getCheckboxParticular($event,item)"></mat-checkbox>           -->
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button *ngIf="Feildproperty.length>0" mat-flat-button color="primary" [disabled]="ExportRecordButton"
      (click)="ExportRecord()">
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
      Export
    </button>
  </mat-dialog-actions>
</ng-template>


<ng-template #downloadDoc>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>cloud_download</mat-icon>
    </span>
     <!-- Broadcast Message -->
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="">    
      <mat-form-field class="example-full-width">
        <mat-label>Placeholder Name</mat-label>
        <input matInput placeholder="Placeholder name" formControlName="placeholderName">
      </mat-form-field>     

    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="formDialog.invalid || !formDialog.dirty"
     (click)="downloadFile(formDialog.value)">
     <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
     Download
    </button>
  </mat-dialog-actions>
</form>
</ng-template>

<app-loader></app-loader>